/* eslint-disable jsx-a11y/anchor-is-valid */

import { Component } from "react";
import axios from "axios";

import { creatBlobFromBase64 } from "../../utils/utils";
import { BACKEND_CONFIG, SURPLUS_LINES_ROUTING } from "../../config/consts";
import carrierMessagesIcon from "../../images/icon-message-alert.svg";
import viewProposalIcon from "../../images/icon-proposal.svg";
import { QuoteSpinnerConsumer } from "../../context/quote-spinner-context";
import { BannerConsumer } from "../../context/banner-context";
import { SlideOutStatusConsumer } from "../../context/slide-out-status-context";

import HeadsUp from "./HeadsUp";
import BindRequestModal from "./BindRequestModal";

class GeneralInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bindInitiationErrorCaseNumber: null,
      isBindRequestSent: true,
      isBindRequestModalOpened: false,
      isBindModalOpened: false,
      isScheduleModificationOpened: false,
      orderMVRError: null,
      showUWReviewLabel: false,
      actions: [],
    };

    this.performQuoteActions = this.performQuoteActions.bind(this);
    this.updateData = this.updateData.bind(this);
    this.viewDocument = this.viewDocument.bind(this);
    this.quoteSpinner = {};
    this.showStatusModal = null;
  }

  viewDocument(clientId, documentId) {
    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}documents/${clientId}/files/${documentId}/content`
      )
      .then(({ data }) => {
        const blob = creatBlobFromBase64(data.Content, data.ContentType);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, data.FileName);
        } else {
          let anchor = document.createElement("a");
          anchor.download = data.FileName;
          const url = window.URL.createObjectURL(blob);
          anchor.href = url;
          anchor.click();
          window.URL.revokeObjectURL(url);
        }
      });
  }

  performQuoteActions(e) {
    e.preventDefault();
    // eslint-disable-next-line default-case
    switch (this.props.selectedAction) {
      case "Requote":
        if (this.props.hasNextScreen) this.props.showRequote();
        else this.props.submit();
        break;
      case "RequestBind":
        this.setState({ isBindRequestModalOpened: true });
        break;
      case "RequestUWReview":
        this.checkSelectValueToUnhideError("SelectAction");
        this.props.requestUWReview(
          this.props.generalInfo.ClientId,
          this.props.generalInfo.PolicyQuoteId,
          SURPLUS_LINES_ROUTING && this.props.generalInfo.SurplusLines
        );
        break;
    }
  }

  isVisible() {
    return BACKEND_CONFIG.get("allstateAgencyFeaturesAllowed");
  }

  updateData(e) {
    const field = e.target.name;
    this.setState({
      [field]: e.target.value,
    });
  }

  render() {
    let generalInfo = this.props.generalInfo;

    return (
      <>
        <SlideOutStatusConsumer>
          {(context) => {
            this.showStatusModal = context.showStatusModal;
          }}
        </SlideOutStatusConsumer>
        <QuoteSpinnerConsumer>
          {(contextState) => {
            this.quoteSpinner.startBouncing = contextState.startBouncing;
            this.quoteSpinner.stopBouncing = contextState.stopBouncing;
            this.quoteSpinner.firePanelLoad = contextState.fireUpdateFunction;
          }}
        </QuoteSpinnerConsumer>
        <BannerConsumer>
          {(context) => {
            this.showError = context.showBanner;
          }}
        </BannerConsumer>
        <div>
          <HeadsUp {...generalInfo} />
          {renderQuoteLobDetails.apply(this)}
          {quoteActions.apply(this)}
          <BindRequestModal
            isVisible={this.state.isBindRequestModalOpened}
            generalInfo={generalInfo}
            viewCallback={this.props.viewCallback}
            history={this.props.history}
            onApplyBindRequest={this.props.onApplyBindRequest}
            closeBindRequestModal={() => {
              this.setState({ isBindRequestModalOpened: false });
            }}
          />
        </div>
      </>
    );

    function renderQuoteLobDetails() {
      if (generalInfo.CarrierId === 100 && generalInfo.LobId === 700) {
        return (
          <div className="lob-details-policy-quote">
            <div
              className="lob-details-policy-quote-description"
              style={{
                flexDirection: "column",
                display: "flex",
              }}
            >
              <div className="error-message" style={{ width: "100%" }}>
                To bind this commercial auto policy with Hartford, it is
                required to either bind the new underlying policy or possess an
                existing underlying policy with Hartford.
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <span>
                  {this.getPolicyQuoteNumberDescription(generalInfo)}
                </span>
                {generalInfo.CarrierProposalDocumentId && (
                  <div
                    style={{
                      flexBasis: "130px",
                      flexGrow: 1,
                    }}
                  >
                    <a
                      className="view-proposal-button"
                      style={{
                        textDecoration: "none",
                      }}
                      rel="noopener noreferrer"
                      target="_blank"
                      onClick={(e) =>
                        this.viewDocument(
                          generalInfo.ClientId,
                          generalInfo.CarrierProposalDocumentId
                        )
                      }
                    >
                      <img
                        src={viewProposalIcon}
                        alt=""
                        style={{ marginRight: "5px" }}
                      />
                      View Proposal
                    </a>
                  </div>
                )}
              </div>
            </div>
            {this.isVisible() &&
              generalInfo.CarrierMessages && generalInfo.CarrierMessages.length > 0 ? (
              <div
                style={{
                  flexBasis: generalInfo.CarrierProposalDocumentId
                    ? "100%"
                    : "160px",
                }}
              >
                <a
                  className="view-proposal-button"
                  style={{
                    textDecoration: "none",
                  }}
                  rel="noopener noreferrer"
                  target="_blank"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.showCarrierMessages(generalInfo);
                  }}
                >
                  <img
                    src={carrierMessagesIcon}
                    alt=""
                    style={{ marginRight: "5px" }}
                  />
                  View Carrier Messages
                </a>
              </div>
            ) : null}
          </div>
        );
      }

      return (
        <div className="lob-details-policy-quote">
          <div
            className="lob-details-policy-quote-description"
            style={{ flexBasis: "150px" }}
          >
            <span>
              {this.getPolicyQuoteNumberDescription(generalInfo)}
            </span>
          </div>
          {generalInfo.CarrierProposalDocumentId && (
            <div
              style={{
                flexBasis: "130px",
                flexGrow: 1,
              }}
            >
              <a
                className="view-proposal-button"
                style={{
                  textDecoration: "none",
                }}
                rel="noopener noreferrer"
                target="_blank"
                onClick={(e) =>
                  this.viewDocument(
                    generalInfo.ClientId,
                    generalInfo.CarrierProposalDocumentId
                  )
                }
              >
                <img
                  src={viewProposalIcon}
                  alt=""
                  style={{ marginRight: "5px" }}
                />
                View Proposal
              </a>
            </div>
          )}
          {generalInfo.CarrierId === 291 && (
            <div style={{ width: "100%", fontSize: 14, color: "#eb3661", padding: "0 10px", lineHeight: 1.25, marginTop: 10 }}>
              Please contact Tapco directly at 866-682-7726 to make changes to the quote or bind coverage, referencing the quote ID.
            </div>
          )}
          {this.isVisible() && generalInfo.CarrierMessages && generalInfo.CarrierMessages.length > 0 ? (
            <div
              style={{
                flexBasis: generalInfo.CarrierProposalDocumentId
                  ? "100%"
                  : "160px",
              }}
            >
              <a
                className="view-proposal-button"
                style={{
                  textDecoration: "none",
                }}
                rel="noopener noreferrer"
                target="_blank"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.showCarrierMessages(generalInfo);
                }}
              >
                <img
                  src={carrierMessagesIcon}
                  alt=""
                  style={{ marginRight: "5px" }}
                />
                View Carrier Messages
              </a>
            </div>
          ) : null}
        </div>
      );
    }

    function quoteActions() {
      if (this.props.actions && this.props.actions.length === 0) {
        return null;
      }

      return (
        <div
          className="view-carrier-messages"
          style={{
            flexBasis:
              generalInfo.CarrierProposalDocumentId ||
                (this.isVisible() && generalInfo.CarrierMessages && generalInfo.CarrierMessages.length > 0)
                ? "100%"
                : "130px",
            flexGrow: 1,
          }}
        >
          <select
            className="quote-actions"
            value={this.props.selectedAction}
            onChange={(e) =>
              this.callUpdateQuoteAndUWValidationLabelCheck(e.target.value)
            }
          >
            <option value={null} key={null}>
              Select Action
            </option>
            {this.props.actions.map((item) => (
              <option value={item.Value} key={item.Value}>
                {item.Name}
              </option>
            ))}
          </select>
          <button
            className="submit-quote-action"
            onClick={this.performQuoteActions}
          >
            Submit
          </button>
          {this.state.showUWReviewLabel && (
            <span className="uw-review-validation-message">
              UW Review can only be requested for one quote per LOB.
            </span>
          )}
        </div>
      );
    }
  }

  callUpdateQuoteAndUWValidationLabelCheck(value) {
    this.checkSelectValueToUnhideError(value);
    this.props.updateQuoteAction(value);
  }

  checkSelectValueToUnhideError(value) {
    const show = value === "RequestUWReview";
    this.setState({ showUWReviewLabel: show });
  }

  getPolicyQuoteNumberDescription(generalInfo) {
    if (generalInfo.IsPolicy) {
      return "POLICY ID #" + generalInfo.Id;
    }

    return "QUOTE ID #" + generalInfo.Id;
  }
}

export default GeneralInfo;
